import "./styles.scss";

import React, { useState } from "react";
import classNames from "classnames";

import { ReactComponent as CheckmarkIcon } from "assets/icons/radio-checkmark.svg";

const mainClass = "radio-buttons";

const RadioButtons = ({ label, options, disabled, onChange }) => {
  const [selected, setSelected] = useState(
    options?.length > 0 ? options.find((item) => item.selected)?.value : null
  );

  if (!(options?.length > 0)) return null;

  return (
    <div className={mainClass}>
      {label && <p>{label}</p>}
      <div className={classNames(`${mainClass}__field`)}>
        {options.map((item) => (
          <button
            key={item.value}
            className={classNames(`${mainClass}__button`, {
              active: selected === item.value,
            })}
            type="button"
            disabled={disabled || item?.disabled}
            onClick={() => {
              if (typeof onChange === "function") {
                onChange(item.value);
              } else {
                if (typeof item?.onChange === "function")
                  item.onChange(item.value);
              }

              setSelected(item.value);
            }}
          >
            {!!item?.icon && (
              <span>
                {typeof item.icon === "string" ? (
                  <img src={item.icon} alt={item.value} />
                ) : (
                  item.icon
                )}
              </span>
            )}
            {item.label}
            <i>
              <CheckmarkIcon />
            </i>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RadioButtons;
